import { _user } from '@/state';
import { ModelDefaults } from "@/state/ModelDefaults";
import { obj } from '@/util';

export class User {

	/*
	|-------------------------------------------------------------
	| Data
	|-------------------------------------------------------------
	*/

	state = () => _user()
	setState = (data = {}) => (Object.assign(this.state(), this.commit(data)))

	static stateDefaults = () => Object.assign({},
		ModelDefaults.User(),
		{
			authenticated: false,
			two_factor_enabled: false,
			login_providers: [],
			tenants: [],
			current_tenant: {},
			role: {},
			permissions: {},
			scopes: {},
			coin_counts: {},
			position: null
		}
	)

	commit = (data = {}) => {
		if (data !== false) {
			let original = Object.assign(this.constructor.stateDefaults(), this);
			Object.assign(this, original, data);
			this.computedData();
			return obj.cleanCopy(this);
		}
		return this.constructor.stateDefaults()
	}

	computedData = () => {
		this.authenticated = !!this.id
		this.setScopes()
	}

	/*
	|-------------------------------------------------------------
	| Authentication
	|-------------------------------------------------------------
	*/

	isAuthenticated = () => !!this.state().authenticated

	isTwoFactorEnabled = () => !!this.state().two_factor_enabled

	emailIsVerified = () => !!this.state().email_is_verified

	getLoginProviders = () => (this.state().login_providers || [])

	/*
	|-------------------------------------------------------------
	| Tenant
	|-------------------------------------------------------------
	*/

	getTenants = () => (this.state().tenants || [])

	getCurrentTenant = () => (this.state().current_tenant || {})

	/*
	|-------------------------------------------------------------
	| Role/ Permissions
	|-------------------------------------------------------------
	*/

	getRole = () => (this.state().role || {})

	isRole = (role = '') => (this.getRole().slug == role)

	getPermissions = () => this.state().permissions

	getScopes = () => this.state().scopes

	setScopes = () => {
		let scopes = {};
		Object.entries(this.permissions).forEach(p => {
			var [key, value] = p;
			if (value) {
				key = key.replace(/^(\S+)\:.*$/, "$1")
				scopes[key] = value;
			}
		});
		this.scopes = scopes
		return this;
	}

	/*
	|-------------------------------------------------------------
	| Permission Helpers
	|-------------------------------------------------------------
	*/

	isAble = (permission = '') => {
		let permissions = this.getPermissions();
		return permissions[permission] || false;
	}

	isUnable = (permission = '') => {
		return !this.isAble(permission);
	}

	isAbleToAny = (permissions = []) => {
		return !permissions.length || !!permissions.filter(p => this.isAble(p)).length
	}

	isAbleToAll = (permissions = []) => {
		return !permissions.length || permissions.filter(p => this.isAble(p)).length === permissions.length
	}

	hasScope = (scope = '') => {
		let scopes = this.getScopes();
		return scopes[scope] || false;
	}

	/*
	|-------------------------------------------------------------
	| Coins
	|-------------------------------------------------------------
	*/

	coins = () => this.state().coin_counts || {}

	currentSprintCoins = () => this.coins().sprint_current || 0

	currentLifetimeCoins = () => this.coins().game_lifetime || 0

	lifetimeCoins = () => this.coins().lifetime || 0

	spendingCoins = () => this.coins().spending || 0

	standing = () => this.state().position || null

	clearStanding = () => {
		delete this.position
		delete this.coin_counts.game_current
		delete this.coin_counts.game_lifetime
		this.setState(this)
		return this
	}

}